import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import PluginShowcase from './components/PluginShowcase';
import PluginDetailPage from './components/PluginDetailPage';
import WorkflowDetailPage from './components/WorkflowDetailPage';
import SignupPage from './components/SignupPage';
import UserDashboard from './components/UserDashboard';
import AdminDashboard from './components/AdminDashboard';
import './App.css';

function App() {
const [user, setUser] = useState(null);
const [isAdmin, setIsAdmin] = useState(false);
const [loading, setLoading] = useState(true);

useEffect(() => {
// Check if user is logged in
const token = localStorage.getItem('token');
const userId = localStorage.getItem('userId');
const email = localStorage.getItem('userEmail');
const fullName = localStorage.getItem('userName');
const nickname = localStorage.getItem('userNickname');
const userRole = localStorage.getItem('userRole');

if (token && userId) {
  setUser({
    token,
    userId,
    email,
    fullName,
    nickname
  });
  setIsAdmin(userRole === 'Admin' || userRole === 'Moderator');
}
setLoading(false);

}, []);

const handleAuth = (userData) => {
setUser(userData);
// Check if user is admin (you might need to decode JWT or get this from API)
const role = userData.role || 'User';
localStorage.setItem('userRole', role);
setIsAdmin(role === 'Admin' || role === 'Moderator');
};

const handleLogout = () => {
localStorage.clear();
setUser(null);
setIsAdmin(false);
};

if (loading) {
return (
<div style={styles.loading}>
<div style={styles.spinner}></div>
<p>Loading...</p>
</div>
);
}

return (
<Router>
<Routes>
{/* Public Routes */}
<Route path="/" element={<PluginShowcase />} />
<Route path="/plugin/:slug/:pluginId" element={<PluginDetailPage />} />
<Route path="/plugin/:slug" element={<PluginDetailPage />} />
<Route path="/workflow/:slug/:workflowId" element={<WorkflowDetailPage />} />
<Route path="/workflow/:slug" element={<WorkflowDetailPage />} />
<Route
path="/login"
element={
user ? <Navigate to={isAdmin ? "/admin" : "/dashboard"} /> : <SignupPage onSignupSuccess={handleAuth} />
}
/>
<Route
path="/signup"
element={
user ? <Navigate to={isAdmin ? "/admin" : "/dashboard"} /> : <SignupPage onSignupSuccess={handleAuth} />
}
/>

    {/* Protected User Routes */}
    <Route 
      path="/dashboard" 
      element={
        user ? (isAdmin ? <Navigate to="/admin" /> : <UserDashboard user={user} onLogout={handleLogout} />) : <Navigate to="/login" />
      } 
    />

    {/* Protected Admin Routes */}
    <Route 
      path="/admin" 
      element={
        user ? (isAdmin ? <AdminDashboard onLogout={handleLogout} /> : <Navigate to="/dashboard" />) : <Navigate to="/login" />
      } 
    />

    {/* Catch all - redirect to home */}
    <Route path="*" element={<Navigate to="/" />} />
  </Routes>
</Router>

);
}

const styles = {
loading: {
display: 'flex',
flexDirection: 'column',
justifyContent: 'center',
alignItems: 'center',
height: '100vh',
background: '#f5f7fa'
},
spinner: {
width: '50px',
height: '50px',
border: '5px solid #e1e8ed',
borderTop: '5px solid #667eea',
borderRadius: '50%',
animation: 'spin 1s linear infinite'
}
};

export default App;
